import React from 'react';
import {
  Button,
  ButtonProps,
  Stack,
  StackProps,
  Typography,
  TypographyProps,
} from '@mui/material';

import { useDispatch } from 'react-redux';
import { TP_COLORS } from '../../../constants';
import { toggleBookTrialModal } from '../../../store/V2/TrialsSlice';

const stackStyles: StackProps = {
  flexDirection: { xs: 'column', sm: 'row' },
  minHeight: '150px',
  padding: '0px 20px',
  justifyContent: { xs: 'space-evenly', sm: 'center' },
  alignItems: 'center',
  sx: {
    background: `url('${process.env.PUBLIC_URL}/images/backgrounds/bg-trial-grid.avif') 0px 0px, ${TP_COLORS.gray.darken}`,
  },
};

const typoProps: TypographyProps = {
  color: '#94A3B8',
  textAlign: 'center',
  fontSize: { xs: '20px', md: '24px', lg: '30px' },
};

const buttonProps: ButtonProps = {
  variant: 'outlined',
  color: 'inherit',
  sx: {
    color: '#F8FAFC',
    padding: { xs: '12px 20px', md: '12px 38px' },
    fontSize: { xs: '16px', sm: '18px', md: '20px' },
    marginLeft: { xs: '0px', sm: '40px', md: '50px' },
    borderRadius: '50px',
    border: '2px solid #F8FAFC',
    background:
      'linear-gradient(107.83deg, #003768 7.88%, #006C9C 41.91%, #39BFB9 82.16%)',
  },
};

const TrialClassBanner: React.FC = () => {
  const dispatch = useDispatch();
  return (
    <section>
      <Stack {...stackStyles}>
        <Typography {...typoProps}>
          You are just one step closer to booking your free trial.
        </Typography>
        <Button
          {...buttonProps}
          onClick={() => dispatch(toggleBookTrialModal())}
        >
          Book A Trial Class
        </Button>
      </Stack>
    </section>
  );
};

export default TrialClassBanner;
